import { render, staticRenderFns } from "./TravelPlanTable.vue?vue&type=template&id=2b03b56a"
import script from "./TravelPlanTable.vue?vue&type=script&lang=js"
export * from "./TravelPlanTable.vue?vue&type=script&lang=js"
import style0 from "./TravelPlanTable.vue?vue&type=style&index=0&id=2b03b56a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports